import React,{useEffect,useState} from 'react'
import Slider from 'react-slick';
import { awardsData } from '../../helper/data';
const RecognizedBy = () => {
      const [isMobile, setIsMobile] = useState(false);
    const [mounted, setMounted] = useState(false);
        useEffect(() => {
        setIsMobile(window.innerWidth <= 768);
        setMounted(true);
        
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 100);
    }, []);
const logoSettings = {
  arrows: false,
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: isMobile ? 3 : 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 3,
              autoplay: true,
              arrows: false,
              dots: false,
          }
      }
  ]
};
if (!mounted) return null;
  return (
    <>
    <section className='section-top-padding'>
        <div className='container'>
            <h2 className='heading-title mb-4'>
                Recognized by Industry Leaders
            </h2>
            <div className="logo-slider">
                <Slider {...logoSettings} >
                    {awardsData?.map(item => {
          return <div className='logo-outer-award'>
                          <img src={item?.imageSrc} alt="logo" />
                </div>
        })}
                </Slider>
            </div>
        </div>
      </section>
    </>
  )
}

export default RecognizedBy